import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function Diagnosis() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayDiagnosis, setDisplayDiagnosis] = useState('none');
  const [displayUpdDiagnosis, setDisplayUpdDiagnosis] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [DiagnosisName, setDiagnosisName] = useState('');
  const [DiagnosisHeading, setDiagnosisHeading] = useState('');
  const [DiagnosisCaption, setDiagnosisCaption] = useState('');
  const [DiagnosisPara1, setDiagnosisPara1] = useState('');
  const [DiagnosisPara2, setDiagnosisPara2] = useState('');
  //  const [uid, setUID] = useState('');
  //  const [specialityType, setSpecialityType] = useState('1');
  const [verfied, setVerfied] = useState(true);
  const [updDiagnosisName, setDiagnosisUpdName] = useState('');
  const [updDiagnosisHeading, setDiagnosisUpdHeading] = useState('');
  const [updDiagnosisCaption, setDiagnosisUpdCaption] = useState('');
  const [updDiagnosisPara1, setDiagnosisUpdPara1] = useState('');
  const [updDiagnosisPara2, setDiagnosisUpdPara2] = useState('');
  const [id, setID] = useState('');
  //  const [uidErr, setUIDErr] = useState('');
  //  const [Err, SetErr] = useState([]);
  const [type, setType] = useState('Diagnostic');
  const [updType, setUpdType] = useState('');

  let txt = "";

  useEffect(() => {
    getDiagnosis()
  }, [])


  function openDiagnosis() {
    setDisplayDiagnosis('block')
  }

  function closeDiagnosis() {
    setDisplayDiagnosis('none')
  }

  function openUpdDiagnosis() {
    setDisplayUpdDiagnosis('block')
  }

  function closeUpdUser() {
    setDisplayUpdDiagnosis('none')
  }

  async function updateDiagnosis(id) {
    // alert(id+','+updType)

    let result = await fetch(apiPath + "diagnostics/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "name": updDiagnosisName,
        "type": updType,
        "heading": updDiagnosisHeading,
        "caption": updDiagnosisCaption,
        "about_para_1": updDiagnosisPara1,
        "about_para_2": updDiagnosisPara2
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDiagnosis()
  }

  async function deleteDiagnosis(id) {

    let result = await fetch(apiPath + "Diagnosiss/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDiagnosis()
  }



  async function updateOperation(id) {

    let result = await fetch(apiPath + "diagnostics/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    console.warn(result.data)

    setDiagnosisUpdName(result.data.name)
    setUpdType(result.data.type);
    setDiagnosisUpdHeading(result.data.heading)
    setDiagnosisUpdCaption(result.data.caption)
    setDiagnosisUpdPara1(result.data.about_para_1)
    setDiagnosisUpdPara2(result.data.about_para_2)

    setID(result.data.id)

    openUpdDiagnosis();
  }


  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Deleting a Diagnosis will DELETE all SPECIALITIES and DOCTORS linked to this departmnt. Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDiagnosis(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL Diagnosis (for initial screen)*/ 

  async function getDiagnosis() {
    let result = await fetch(apiPath + "diagnostics",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDataStat(result.success);
    setData(result.data);

    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
      setUID(item)
    }
  }
*/}

  function verifyDiagnosis() {
    setVerfied(true)
    addDiagnosis()
  }

  //*ADD A NEW Diagnosis*/ 
  async function addDiagnosis() {
    //    alert('Add,'+DiagnosisName)
    if (verfied) {

      let result = await fetch(apiPath + "diagnostics", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": DiagnosisName,
          "type": type,
          "heading": DiagnosisHeading,
          "caption": DiagnosisCaption,
          "about_para_1": DiagnosisPara1,
          "about_para_2": DiagnosisPara2
        })
      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getDiagnosis()
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>


      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>

          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Diagnostic/Clinic Management</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openDiagnosis} type="button" name="button"
                className="btn solid round">Create Diagnosis</button>
            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="15%">Name</th>
                  <th className="th-border left" width="10%">Type</th>
                  <th className="th-border left" width="15%">Heading</th>
                  <th className="th-border left" width="20%">Caption</th>
                  <th className="th-border left" width="25%">About Para 1</th>
                  <th className="th-border left" width="25%">About Para 2</th>
                  <th className="th-border left" width="5%">Edit</th>
                  {/*      <th className="th-border left" width="5%">Delete</th>  */}
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.name}</td>
                          <td className="left">{item.type}</td>
                          <td className="left">{item.heading}</td>
                          <td className="left">{item.caption}</td>
                          <td className="left">{item.about_para_1}</td>
                          <td className="left">{item.about_para_2}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          {/*                          <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>  */}
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW USER */}

          <div id="newdept" style={{ 'display': displayDiagnosis }} className="cont__new-deptDetails">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeDiagnosis}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Diagnosis / Clinic</h2>
                  <br />
                  <div className="row">
                    <div className="c12-l-1"></div>
                    <div className="c12-l-11">
                      <div className="row">
                        <div className='c12-l-8'>
                          <p style={{ 'fontSize': '0.65rem' }}>Diagnosis Name</p>
                          <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                            placeholder="Diagnosis Name" onChange={(e) => setDiagnosisName(e.target.value)} />
                        </div>
                        <div className='c12-l-1'></div>
                        <div className='c12-l-3'>
                          <p style={{ 'fontSize': '0.65rem' }}>type</p>
                          <select className="custom-select" onChange={(e) => setType(e.target.value)}>
                            <option value="Diagnostic" >Diagnostic</option>
                            <option value="Clinic" >Clinic</option>
                          </select>
                        </div>
                      </div>

                      <p style={{ 'fontSize': '0.65rem' }}>Heading</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off" maxlength="100"
                        placeholder="Heading (maximum 100 Character)" onChange={(e) => setDiagnosisHeading(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Caption</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="350" rows="3"
                        placeholder="Caption (maximum 350 Character)" onChange={(e) => setDiagnosisCaption(e.target.value)} />

                      <div className="row">
                        <div className="c12-l-1"><h3>About</h3></div>
                        <div className="c12-l-11">

                          <p style={{ 'fontSize': '0.65rem' }}>Para-1</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-1 (maximum 500 Character)" onChange={(e) => setDiagnosisPara1(e.target.value)} />

                          <p style={{ 'fontSize': '0.65rem' }}>Para-2 (optional)</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-2 (maximum 500 Character)" onChange={(e) => setDiagnosisPara2(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button onClick={verifyDiagnosis} type="button"
                    className="btn solid round">Add Diagnosis</button>
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdDiagnosis }} className="cont__new-deptDetails">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Diagnosis</h2><br />
                  <div className="row">
                    <div className="c12-l-1"></div>
                    <div className="c12-l-11">

                      <input type="hidden" value={id} />

                      <div className="row">
                        <div className="c12-l-12">
                          <div className="row">
                            <div className='c12-l-8'>
                              <p style={{ 'fontSize': '0.65rem' }}>Diagnosis Name</p>
                              <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small"
                                placeholder="Name of the Diagnosis" onChange={(e) => setDiagnosisUpdName(e.target.value)}
                                value={updDiagnosisName} />
                            </div>
                            <div className='c12-l-1'></div>
                            <div className='c12-l-3'>
                              <p style={{ 'fontSize': '0.65rem' }}>type</p>
                              <select className="custom-select" onChange={(e) => setUpdType(e.target.value)}>
                                <option value="Diagnostic" >Diagnostic</option>
                                <option value="Clinic" >Clinic</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <p style={{ 'fontSize': '0.65rem' }}>Heading</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off" maxlength="100"
                        placeholder="Heading (maximum 100 Character)" onChange={(e) => setDiagnosisUpdHeading(e.target.value)}
                        value={updDiagnosisHeading} />

                      <p style={{ 'fontSize': '0.65rem' }}>Caption</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="350" rows="3"
                        placeholder="Caption (maximum 350 Character)" onChange={(e) => setDiagnosisUpdCaption(e.target.value)}
                        value={updDiagnosisCaption} />

                      <div className="row">
                        <div className="c12-l-1"><h3>About</h3></div>
                        <div className="c12-l-11">

                          <p style={{ 'fontSize': '0.65rem' }}>Para-1</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-1 (maximum 500 Character)" onChange={(e) => setDiagnosisUpdPara1(e.target.value)}
                            value={updDiagnosisPara1} />

                          <p style={{ 'fontSize': '0.65rem' }}>Para-2 (optional)</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-2 (maximum 500 Character)" onChange={(e) => setDiagnosisUpdPara2(e.target.value)}
                            value={updDiagnosisPara2} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button onClick={() => { updateDiagnosis(id) }} type="button"
                    className="btn solid round">Update Diagnosis</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Diagnosis;
